<template>
  <div class="noneDinnerPage">
    <div class="timeSelect">
      <van-field
        v-model="noneOrderDate"
        readonly
        @click="TimePicker"
        class="timeInput"
      />
      <van-icon name="arrow" class="arrowRight" />
      <van-icon name="arrow-left" class="arrowLeft" />
    </div>
    <van-search
      v-model="searchValue"
      @input="renewalDinnerList"
      placeholder="请输入姓名/部门名称"
    />
    <div class="dinnerDetail">
      <ul class="dinnerTitle clearfix" v-if="noneDinnerList[0]">
        <li class="fl">部门</li>
        <li class="fl">人员</li>
        <li class="fl">类型</li>
      </ul>
      <div class="list-content" id="listNoneContent">
        <van-list
          v-model="noneLoading"
          :finished="noneFinished"
          @load="onLoad"
          :offset="100"
          noneFinished-text="没有更多了"
        >
          <div class="list-item">
            <van-cell
              v-for="item in noneDinnerList"
              :key="item.id"
              class="item"
            >
              <div class="deptName">{{ item.deptName }}</div>
              <div class="childList">
                <van-cell
                  v-for="itemChild in item.children"
                  :key="itemChild.id"
                >
                  <span>{{ itemChild.realName }}</span>
                  <span>{{ itemChild.reason }}</span>
                </van-cell>
              </div>
            </van-cell>
          </div>
        </van-list>
        <div class="nonePage" v-if="noneDinnerList.length == '0'">
          <img :src="nonePng" />
          <p>暂无数据</p>
        </div>
      </div>
      <ul class="total dinnerTitle clearfix" v-if="noneDinnerList[0]">
        <li class="fl">总计</li>
        <li class="fl">{{ commentCount }}人</li>
      </ul>
    </div>
    <!-- 时间控件 -->
    <van-popup v-model="noneShowTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="noneShowTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { MapByJsonKey, dateTimeFormat } from "@/utils/common";
export default {
  name: "noneDinner",
  data() {
    return {
      nonePng: nonePng, //默认图片
      searchValue: "",
      backstagelists: [],
      noneDinnerList: [],
      arrlist: [],
      page: 0,
      pageSize: 20,
      noneLoading: false, //是否处于加载状态
      noneFinished: false, //是否已加载完所有数据
      noneLoading: false, //是否处于下拉刷新状态
      commentCount: 0,
      noneOrderDate: "",
      noneShowTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2020, 0, 1),
      clientType: "", //手机类型
    };
  },
  mounted() {
    let winHeight = document.documentElement.clientHeight; //视口大小
    document.getElementById("listNoneContent").style.height =
      winHeight - 195 + "px"; //调整上拉加载框高度
    let currentTime = new Date().getTime(); //当天此刻时间戳
    let lateTenTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        2 * 60 * 60 * 1000
    ).getTime(); //当天晚上10点的时间戳

    this.noneOrderDate =
      lateTenTime > currentTime
        ? dateTimeFormat(this.currentDate).substr(0, 10)
        : this.getNextOrderDate();

    this.getTest();
  },
  methods: {
    getNextOrderDate() {
      let currentDay = new Date();
      currentDay.setTime(currentDay.getTime() + 24 * 60 * 60 * 1000);
      let tomorrowDay =
        currentDay.getFullYear() +
        "-" +
        (currentDay.getMonth() + 1) +
        "-" +
        currentDay.getDate();

      return tomorrowDay;
    },
    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.baseCommon.Dinner.dinnerList(_this.page, _this.pageSize, {
        fuzzySelect: _this.searchValue,
        isOrder: false,
        orderDate: _this.noneOrderDate,
      })
        .then((res) => {
          if (res.code == "1") {
            let total = parseInt(res.data.total);
            _this.commentCount = total;
            _this.backstagelists = res.data.list;
            _this.backstagelists.forEach((item) => {
              item.reason = item.leaveName
                ? item.leaveName
                : item.reason == "leave"
                ? "请假"
                : "出差";
            });
            _this.viewLists();
            // 加载状态结束
            // _this.loadingShow = false;
            _this.noneLoading = false;

            if (_this.page * 10 >= total) {
              _this.noneFinished = true;
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    viewLists() {
      this.arrlist = this.arrlist.concat(this.backstagelists);
      this.noneDinnerList = MapByJsonKey("deptName", this.arrlist);
    },
    renewalDinnerList() {
      //搜索更新用餐列表
      let _this = this;
      _this.page = 0;
      _this.pageSize = 20;
      _this.commentCount = 0;
      _this.backstagelists = [];
      _this.noneDinnerList = [];
      this.arrlist = [];
      _this.noneLoading = false; //是否处于加载状态
      _this.noneFinished = false; //是否已加载完所有数据
      _this.noneLoading = false; //是否处于下拉刷新状态
      _this.getTest();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
    /*获取时间控件*/
    TimePicker() {
      this.noneShowTimePicker = true;
    },
    /*获取时间数据*/
    onTimeConfirm(data) {
      this.noneShowTimePicker = false;
      this.noneOrderDate = dateTimeFormat(data).substr(0, 10);
      this.renewalDinnerList();
    },
  },
};
</script>
<style lang="less">
.noneDinnerPage {
  width: 100%;
  height: 100%;

  .timeInput.van-cell::after {
    content: none;
  }
  .timeSelect {
    width: 100%;
    position: relative;
    .arrowRight {
      font-size: 15px;
      position: absolute;
      top: 50%;
      margin-top: -4px;
      right: 20%;
      color: #666;
    }
    .arrowLeft {
      font-size: 15px;
      position: absolute;
      top: 50%;
      margin-top: -4px;
      left: 20%;
      color: #666;
    }
  }
  .timeInput {
    width: 100%;

    height: 35px;

    // border-bottom: 1px solid #ebedf0;
    .van-field__control {
      font-size: 15px;
      color: #666;
      text-align: center;
    }
  }
  .dinnerDetail {
    .dinnerTitle {
      width: 100%;
      height: 45px;
      background-color: #f6f6f6;
      border-bottom: 1px solid #ebedf0;

      li {
        font-size: 14px;
        line-height: 45px;
        color: #666;
        float: left;
        text-align: center;
      }
      li:first-child {
        width: 40%;
      }
      li:nth-child(2) {
        width: 30%;
      }
      li:nth-child(3) {
        width: 30%;
      }
    }
    .list-content {
      width: 100%;
      overflow-y: scroll;
      position: relative;
      .list-item {
        width: 100%;
        .item {
          padding: 0;
          border-bottom: 1px solid #ebedf0;
          position: relative;
          div.deptName {
            text-align: center;
            display: inline-block;
            width: 40%;
            height: 34px;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px;
            line-height: 34px;
          }
          div.childList {
            float: right;
            text-align: center;
            display: inline-block;
            width: 60%;
            box-sizing: border-box;
            border-left: 1px solid #ebedf0;
            .van-cell {
              padding: 0;
              width: 100%;
              height: 35px;
              line-height: 35px;
              border-bottom: 1px solid #ebedf0;
              span {
                display: inline-block;
                width: 50%;
                text-align: center;
              }
              span:first-child {
                box-sizing: border-box;
                border-right: 1px solid #ebedf0;
              }
            }
            .van-cell:last-child {
              border-bottom: 0 none;
            }
            .van-cell::after {
              content: none;
            }
          }
        }
        .item.van-cell::after {
          content: none;
        }
      }
      .nonePage {
        width: 120px;
        height: 150px;

        position: absolute;
        left: 50%;
        margin-left: -60px;
        top: 50%;
        margin-top: -75px;

        img {
          display: block;
          max-width: 100px;
          max-height: 100px;
          margin: 0 auto;
        }

        p {
          margin-top: 10px;
          text-align: center;
          color: #5c5d5d;
          font-size: 16px;
        }
      }
    }
    .total.dinnerTitle {
      width: 100%;
      height: 45px;
      position: fixed;
      bottom: 0;
      left: 0;
      border-bottom: 0 none;
      box-sizing: border-box;

      li {
        width: 50%;
        text-align: center;
      }
    }
  }
}
</style>